/**
 * Email Audit Page
 * Wrapper page for Email Audit Trail component
 */

import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import EmailAuditTrail from '../../components/admin/EmailAuditTrail';

function EmailAuditPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Email Audit Trail
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        View and search email notification history
      </Typography>
      <Paper sx={{ p: 2 }}>
        <EmailAuditTrail />
      </Paper>
    </Box>
  );
}

export default EmailAuditPage;
